import { useContext } from "react";
import { useQuery } from "react-query";
import { apiAxios } from "services/HttpServices";
import { LoginStateContext } from "context/Login/LoginState";

async function fetchBindings() {
  try {
    const res = await apiAxios.get("/jobs/bindings");
    return res.data.data;
  } catch (e) {
    console.log(e);
  }
}

function useBindingData() {
  const { user: userState } = useContext(LoginStateContext);

  return useQuery(["bindings"], fetchBindings, {
    enabled: userState.isLoggedIn,
  });
}

export default useBindingData;
